import { useContext } from 'react';
import { AuthContext } from '../context/UserContext';

export function useTitleAndUser() {
  const context = useContext(AuthContext);

  return context;
}
